import moment from 'moment';
import { FC, useState } from 'react';
import { useEventBus } from '../../../../../hooks/use-event-bus';
import { ButtonArea } from '../../../../shared/button-area/button-area';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../shared/appointment-ended-message/appointment-ended-message';
import { InsuranceInfo } from '../shared/insurance-info/insurance-info';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const PayerNotSetupStatusDialog: FC = () => {
  const { publish } = useEventBus();
  const { opened, onClose, isLoading, locationId, patientInfo, selectedIvSummary, getCarrierSummary, appointment } =
    usePatientIvStatusDialog();
  const [carrierSummary] = useState(getCarrierSummary(selectedIvSummary?.idCarrierName));

  const onSetupPayerClick = async () => {
    publish({
      messageType: 'navigate',
      data: {
        pathname: '/insurance/dashboard',
        crossFrame: true
      }
    });

    onClose();
  };

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Payer Not Setup or Not Supported"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateReceived && (
            <>&nbsp;- Run {moment.utc(selectedIvSummary?.dateReceived).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '20px 0 20px 0', display: 'block' }}>
        The following error(s) were encountered during the insurance verification process:
        <ul>
          <li>
            Missing payer setup for insurance identifier: <BoldText>{carrierSummary?.name}</BoldText>
          </li>
        </ul>
        <br />
        To retry verification, please click "Setup Payer" below to complete the setup for this insurance identifier.
        <br />
        <br />
        Alternatively, you may choose "Manually Verified" if you prefer to verify yourself, or "Self Pay" if the patient
        opts not to use insurance.
      </DialogSubTitle>
      <br />
      <ButtonArea title="Fix Now" buttons={[{ title: 'Setup Payer', onClick: onSetupPayerClick }]} />
      {patientInfo && <InsuranceInfo patientInfo={patientInfo} />}
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(PayerNotSetupStatusDialog);
